import { Switch, Route } from "react-router-dom";

// Pages.
import EnquiryForm from "components/EnquiryForm";
import FloorsPlanPage from "pages/sun_capital/floors-plan/FloorsPlanPage";
import ProjectGalleryPage from "pages/sun_capital/gallery/ProjectGalleryPage";
import FacilitiesPage from "pages/sun_capital/facilities/ProjectFacilitiesPage";
import ProjectLocationPage from "pages/sun_capital/location/ProjectLocationPage";
import PresentationPage from "pages/sun_capital/presentation-page/ProjectPresentationPage";

// Nested Routes.
import MasterPlan from "./master-plan";
import Page_360 from "pages/Page-360";

const Index = () => {
  return (
    <Switch>
      <Route exact path={`/sun_capital/presentation`}>
        <PresentationPage />
      </Route>
      <Route exact path={`/sun_capital/location`}>
        <ProjectLocationPage />
      </Route>
      <Route exact path={`/sun_capital/gallery`}>
        <ProjectGalleryPage />
      </Route>
      <Route exact path={`/sun_capital/enquiry-form`}>
        <EnquiryForm />
      </Route>
      <Route exact path={`/sun_capital/view-360`}>
        <Page_360 />
      </Route>
      <Route exact path={`/sun_capital/floors-plan`}>
        <FloorsPlanPage />
      </Route>
      <Route exact path={`/sun_capital/facilities`}>
        <FacilitiesPage />
      </Route>
      <MasterPlan />
    </Switch>
  );
};

export default Index;
